import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Settings2 } from "lucide-react";
import { api } from "../../lib/api";

export const RewardSettingsPanel = () => {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.rewardSettings().then(setForm); }, []);
  if (!form) return null;

  const save = async () => {
    setSaving(true);
    try {
      setForm(await api.saveRewardSettings({ reward_mb: Number(form.reward_mb), validity_days: Number(form.validity_days), terms_url: form.terms_url?.trim() || null }));
      toast.success("Reward settings saved");
    } catch { toast.error("Check the values (validity 1–365 days, URL must be /terms or start with http:// or https://)"); } finally { setSaving(false); }
  };

  return (
    <div className="px-6 py-4 border-b border-white/10 bg-[#121212]" data-testid="reward-settings-panel">
      <div className="label flex items-center gap-1 mb-3"><Settings2 className="w-3 h-3" /> Reward settings</div>
      <div className="flex flex-wrap items-end gap-4">
        <label className="block">
          <span className="text-[10px] text-neutral-500 uppercase tracking-wider">Award per successful scan (MB, 1 per week)</span>
          <input data-testid="reward-rate-input" type="number" min="0" step="50" value={form.reward_mb}
            onChange={(e) => setForm({ ...form, reward_mb: e.target.value })} className="field block w-48 mt-1" />
        </label>
        <label className="block">
          <span className="text-[10px] text-neutral-500 uppercase tracking-wider">Data valid for (days after loading)</span>
          <input data-testid="reward-validity-days-input" type="number" min="1" max="365" value={form.validity_days}
            onChange={(e) => setForm({ ...form, validity_days: e.target.value })} className="field block w-48 mt-1" />
        </label>
        <label className="block flex-1 min-w-[280px]">
          <span className="text-[10px] text-neutral-500 uppercase tracking-wider">Terms & conditions page URL</span>
          <input data-testid="reward-terms-url-input" type="url" placeholder="/terms (built-in page) or https://..." value={form.terms_url || ""}
            onChange={(e) => setForm({ ...form, terms_url: e.target.value })} className="field block w-full mt-1" />
        </label>
        <button data-testid="save-reward-settings-button" onClick={save} disabled={saving} className="btn-primary px-5 py-2.5 text-xs">
          {saving ? "Saving…" : "Save"}
        </button>
      </div>
      <div className="text-[10px] text-neutral-600 mt-2">New rate applies to future scans only; validity applies to bundles marked redeemed from now on. Already-earned rewards keep their value. Default /terms opens the built-in Cell Checkpoint Promotion terms page.</div>
    </div>
  );
};
